import React, { useMemo } from 'react'
import { ANALITYCS_InvestorFordStartInvestingButtonIds } from '@constants/analitycs-ids'
import { PageSettings } from '@http/api-models/page-settings'
import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import PageAnimation from '@shared/components/page-animation'

import { SectionActivate } from './SectionActivate'
import { SectionApps } from './SectionApps'
import { SectionBanks } from './SectionBanks'
import { goToCalculatorLink, SectionBuyCertificate } from './SectionBuyCertificate'
import { SectionHow } from './SectionHow'
import { SectionMain } from './SectionMain'
import { SectionProtected } from './SectionProtected'

export interface InvestorsFondPageProps {
	pageSettings: PageSettings & {
		pledgeSummary?: PledgeSummaryResponse | undefined
	}
}

export const InvestGift = ({ pageSettings }: InvestorsFondPageProps) => {
	const { maxCashback, maxValue, minValue } = useMemo(() => {
		return (
			pageSettings?.savings?.params ||
			({
				maxCashback: '0',
				maxValue: '0',
				minValue: '0',
			} as any)
		)
	}, [pageSettings])

	return (
		<PageAnimation>
			<SectionMain
				buttonProps={{
					id: ANALITYCS_InvestorFordStartInvestingButtonIds(0),
					onClick: goToCalculatorLink,
				}}
			/>
			<SectionBanks />
			<SectionBuyCertificate />
			<SectionActivate />
			<SectionHow maxCashback={maxCashback} maxValue={maxValue} minValue={minValue} />
			<SectionProtected />
			<SectionApps />
		</PageAnimation>
	)
}
